// extracted by mini-css-extract-plugin
export default {"card":"post_card__Ky79e","btn":"post_btn__r6eAm"};